import React, { useEffect, memo, useMemo } from "react";
import { Button } from "react-bootstrap";
import {
  TextField,
  FormControl,
  InputLabel,
  InputAdornment,
  OutlinedInput,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Divider,
} from "@material-ui/core";
import { Table, Spinner } from "react-bootstrap";
import { Edit, RemoveCircle, Add, Delete, People } from "@material-ui/icons";
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import "./style.css"
/*
 *   ============== Util ===================
 * */
import { DateTimeFormat } from "../../../../util/DateTimeFormat";
import { DateFormat } from "../../../../util/DateFormat";
import { CurrencyFormat } from "../../../../util/currencyFormat";
import { calculateExpiration, CouponTypes } from "../helper";

const CouponTable = ({ isRequesting, couponList, activeTab, onEdit, onDelete, onShowHistory, onPickerUser }) => {
  const checkoutTap = () => {
    // if(activeTab === 1 || activeTab === 3 ) return false;
    if(activeTab === 3 && activeTab !== 1) return false;
    return true;
  }
  const renderTableBody = (couponList) =>
    couponList.map((coupon, index) => (
      <tr key={index}>
        <td>{coupon?.code}</td>
        <td>{coupon?.name || "-"}</td>
          <td className="truncate-text">{coupon?.description || "-"}</td>
        {!checkoutTap() && <td>{coupon?.type || "-"}</td>}
        {(checkoutTap() && activeTab !== 1) && <td>{DateFormat(coupon?.validFrom) || "-"}</td>}
        {(checkoutTap() && activeTab !== 1) && <td>{DateFormat(coupon?.validTo) || "-"}</td> }
        {!checkoutTap() && <td style={{whiteSpace:"nowrap"}}>{`${coupon.valid_date} (${coupon.validity_type})`  || "-"}</td> }
        {activeTab === 1 && <td style={{whiteSpace:"nowrap"}}>{`${!coupon.validTo ? "-": calculateExpiration(coupon.validTo,coupon.validity_type||"day").remainingDays} (day)`  || "-"}</td> }
        <td>
          {coupon?.isPrivate ? (
            <Chip
              variant="outlined"
              size="small"
              label="Private"
              color="primary"
            />
          ) : coupon?.isPrivate === false ? (
            <Chip
              variant="outlined"
              size="small"
              label="Public"
              color="secondary"
            />
          ) : (
            <></>
          )}
        </td>
        <td>
          {coupon?.discountPercentage
            ? coupon?.discountPercentage + " % "
            : coupon?.discountFixedPrice
            ? CurrencyFormat(coupon?.discountFixedPrice)
            : "-"}
        </td>
        <td>{coupon?.amount || "-"}</td>
        <td>{coupon?.usedCount || "-"}</td>
        <td>{CurrencyFormat(coupon?.minimumBasketPrice) || "-"}</td>
        <td>{CurrencyFormat(coupon?.free_delivery_bucket_value || 0)}</td>
        <td className="d-flex justify-content-center">
          <Tooltip title="Click to edit coupon" placement="top" arrow>
            <Button variant="info" onClick={() => onEdit(coupon)}>
              <Edit></Edit>
            </Button>
          </Tooltip>
          &nbsp;&nbsp;
          {
            activeTab === 2 && 
            <Tooltip title="Click to view history" placement="top" arrow onClick={(e) => onShowHistory(coupon)}>
                <Button variant="warning">
                    <People className="text-white"></People>
                </Button>
            </Tooltip>
          }
          {
            (activeTab === 1 || activeTab === 0 || activeTab === 3) && 
            <Tooltip title="Click to Delete" placement="top" arrow onClick={(e) => onDelete(coupon)}>
                <Button variant="danger">
                    <Delete className="text-white"></Delete>
                </Button>
            </Tooltip>
          }
          &nbsp;&nbsp;
          {
            ((activeTab === 1 || activeTab === 3) && coupon?.type != CouponTypes.Registration) &&
            <Tooltip title="Click to Picker User" placement="top" arrow onClick={(e) => onPickerUser(coupon)}>
                <Button variant="info">
                    <PersonAddIcon className="text-white"></PersonAddIcon>
                </Button>
            </Tooltip>
          }
        </td>
      </tr>
    ));

  const tableBody = useMemo(() => renderTableBody(couponList), [couponList]);

  let tableContent = null;
  if (isRequesting && !couponList.length) {
    tableContent = (
      <tr>
        <td colSpan={12} className="text-center">
          <Spinner animation="grow" />
        </td>
      </tr>
    );
  } else if (!couponList.length) {
    tableContent = (
      <tr>
        <td colSpan={12} className="text-center">
          No data
        </td>
      </tr>
    );
  } else {
    tableContent = tableBody;
  }

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Code</th>
          <th>Name</th>
          <th>Description</th>
          {(!checkoutTap())  && <th>Template Use For</th>}
          {(checkoutTap() && activeTab !== 1) && <th>Start Date</th>}
          {(checkoutTap() && activeTab !== 1) && <th>End Date</th>}
          {(!checkoutTap())  && <th>Validity</th>}
          {activeTab === 1  && <th>Remaining Day</th>}
          <th>Type</th>
          <th>Discount</th>
          <th>Quantity</th>
          <th>Used Quantity</th>
          <th>Min Backet Price ($)</th>  
          <th>Min Backet Value For Free Delivery ($)</th>
          <th className="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>{tableContent}</tbody>
    </Table>
  );
};

export default memo(CouponTable);
